module.exports = __webpack_public_path__ + "img/mobileapp2.983600d3.svg";